import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import * as Routes from '../../../../constants/routes';
import { trackingEvent } from '../../../../helpers/tracking';
import { getMortgageTerms } from '../../../../../reducers/mortgage';
import LoadingState from '../../../../common/components/loading';

const tracking = {
    eventAction: 'Mortgage Calculator - Let\'s Go',
    eventLabel: 'Let\'s Go'
};

class Intro extends Component {
    componentWillMount() {
        const {
            props: {
                getMortgageTerms
            }
        } = this;

        getMortgageTerms();
    }

    render() {
        const {
            props: {
                apiLoading,
                apiError,
                mortgageTerms
            }
        } = this;

        const loading = (apiLoading || !mortgageTerms) && !apiError;

        return (
            <div className={styles.page}>
                {
                    loading &&
                    <LoadingState title='Loading Calculator'/>
                }
                <div className={loading ? styles.contentContainerLoading : styles.contentContainer}>
                    {
                        (apiError || !mortgageTerms || mortgageTerms.length === 0) &&
                        [
                            <h1 key='title' className={styles.mainTitleError}>Oh No!</h1>,
                            <p key='text' className={styles.text}>
                                There seems to be an error with the calculator. Please try again later.
                            </p>,
                            <a
                                key='button'
                                href='https://www.libro.ca/buying-house' className={styles.button}
                                title='Learn More about Buying a Home'
                            >
                                Learn More about Buying a Home
                            </a>
                        ]
                    }
                    {
                        mortgageTerms && mortgageTerms.length > 0 &&
                        [
                            <h1 key='title' className={styles.mainTitle}>Mortgage Affordability Calculator</h1>,
                            <p key='text' className={styles.text}>
                                Buying a home? Our Mortgage Calculator is a great place to start - it’s easier to look when you know what you can afford.
                            </p>,
                            <Link
                                key='button'
                                to={`${process.env.PUBLIC_URL}/mortgage${Routes.STEPONE}`}
                                rel='nofollow'
                                onClick={() => trackingEvent(tracking)}
                                className={styles.button}
                                title='Start calculating your mortgage'
                            >
                                Let's Go!
                            </Link>
                        ]
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ mortgage }) => ({
    apiLoading: mortgage.isLoading,
    apiError: mortgage.hasError,
    mortgageTerms: mortgage.terms
});

const mapDispatchToProps = (dispatch) => ({
    getMortgageTerms: () => dispatch(getMortgageTerms)
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    getMortgageTerms: dispatchProps.getMortgageTerms(),
    ...ownProps
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Intro);
